<template>
  <div class="container">
    <div id="header" class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="销售单号">
            <el-input style="width:200px" v-model="formInline.saleNumber" placeholder="交易号或马帮销售单号" clearable />
          </el-form-item>
          <el-form-item label="物流单号">
            <el-select
                style="width:200px"
                v-model="formInline.receiveNumber"
                filterable
                allow-create
                clearable
                @clear="formInline.receiveNumber=''"
                :placeholder="请输入物流单号"
                remote-show-suffix
                class="mobile-select"
            >
              <el-option
                  v-for="item in receiveList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="产品相关">
            <el-input style="width:200px" v-model="formInline.receiveMaterSku" placeholder="产品SKU,名称,序列号" clearable />
          </el-form-item>
          <el-form-item label="国家">
            <el-select
                v-model="formInline.country"
                clearable
                collapse-tags
                collapse-tags-tooltip
                multiple
                filterable
                @clear="formInline.country=''"
                :placeholder="请选择国家"
                remote-show-suffix
                class="mobile-select"
                style="width: 200px"
            >
              <el-option
                  v-for="item in countryList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="入库仓库">
            <el-select
                v-model="formInline.warehouseId"
                filterable
                clearable
                @clear="formInline.warehouseId=''"
                :placeholder="请选择入库仓库"
                remote-show-suffix
                class="mobile-select"
            >
              <el-option
                  v-for="item in stockList"
                  :key="item.warehousefCode"
                  :label="item.warehouseName"
                  :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
                @clear="formInline.status=''"
                v-model="formInline.status"
                clearable
                collapse-tags
                collapse-tags-tooltip
                multiple
                placeholder="请选择物流/马帮/仓库签收状态"
                remote-show-suffix
                style="width: 200px"
            >
              <el-option
                  v-for="item in resiveList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="退单创建时间">
            <el-date-picker
                style="width: 150px"
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.startMonth"
                type="date"
                placeholder="创建时间"
                clearable
                @clear="formInline.startMonth=''"
            />
            -
            <el-date-picker
                style="width: 150px"
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.endMonth"
                type="date"
                placeholder="创建时间"
                clearable
                @clear="formInline.endMonth=''"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button type="warning" @click="showTimeoutWarning">超时预警</el-button>
            <el-button type="danger" @click="exportData">导出记录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
            @sort-change="handleSortChange"
            @selection-change="handleSelectionChange"
        >
          <el-table-column
              label="交易号"
              min-width="100"
              prop="saleOrder"
          ></el-table-column>
          <el-table-column
              label="马帮订单编码"
              min-width="100"
              prop="receiveSaleNumber"
          ></el-table-column>
          <el-table-column
              label="登记日期"
              min-width="100"
              prop="createDate"
          ></el-table-column>
          <el-table-column
              label="国家"
              min-width="60"
              prop="country"
          ></el-table-column>
          <el-table-column
              label="产品SKU"
              min-width="100"
              prop="receiveMaterSku"
          ></el-table-column>
          <el-table-column
              label="产品名称"
              min-width="100"
              prop="receiveMaterName"
          ></el-table-column>
          <el-table-column
              label="产品图片"
              width="175"
              prop="pictureUrl"
          >
            <template #default="scope">
              <MyImage :picture-url="scope.row.pictureUrl" :picture-url-list="[scope.row.pictureUrl] "></MyImage>
            </template>
          </el-table-column>
          <el-table-column
              label="退货数量"
              min-width="60"
              prop="quantity"
          >
          </el-table-column>
          <el-table-column
              label="物流渠道"
              min-width="80"
              prop="returnTrackType"
          ></el-table-column>
          <el-table-column
              label="退货物流"
              min-width="80"
              prop="receiveNumber"
          ></el-table-column>
          <el-table-column
              label="物流状态"
              min-width="150"
              prop="trackStatus"
          >
            <template #default="scope">
              <div>
                物流状态：
                <span >{{ scope.row.trackStatus }}</span>
              </div>
              <div>
                包裹状态：<span >{{scope.row.packageStatus}}</span>
              </div>
              <div>
                事件时间：<span >{{scope.row.trackTime}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="签收地址"
              min-width="150"
              prop="trackStatus"
          >
            <template #default="scope">
              <div>
                地址邮编：<span >{{ scope.row.receiveAddress.recipientPostalCode }}</span>
              </div>
              <div>
                国家：<span >{{scope.row.receiveAddress.recipientCountry}}</span><br>
                省/州：<span >{{scope.row.receiveAddress.recipientProvince}}</span><br>
                市：<span >{{scope.row.receiveAddress.recipientCity}}</span><br>
                区域：<span >{{scope.row.receiveAddress.recipientDistrict}}</span><br>
                街道：<span >{{scope.row.receiveAddress.recipientDetailAddress}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="签收仓库"
              min-width="150"
              prop="receiveWarehouse"
          >
            <template #default="scope">
              <div>
                马帮：
                <span >{{ scope.row.receiveWarehouse ? scope.row.receiveWarehouse :"未签收" }}</span>
              </div>
              <div>
                售后仓：<span >{{ scope.row.stockWarehouseName ? scope.row.stockWarehouseName :"未签收" }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="签收人"
              width="150"
              prop="receiveName"
          >
            <template #default="scope">
              <div>
                马帮：<span >{{ scope.row.employeeName ? scope.row.employeeName :"无" }}</span>
              </div>
              <div>
                售后仓：<span >{{ scope.row.receiveName ? scope.row.receiveName :"无" }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="时间"
              width="180"
              prop="receiveDate"
          >
            <template #default="scope">
              <div>
                马帮签收时间：<span >{{ scope.row.inspectionTime ? scope.row.inspectionTime :"未签收" }}</span>
              </div>
              <div>
                售后仓签收时间：<span >{{ scope.row.receiveDate ? scope.row.receiveDate :"未签收" }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="签收状态"
              min-width="180"
              prop="receiveStatus"
          >
            <template #default="scope">
              <div>
                马帮退货状态：<span v-if="scope.row.receiveStatus==1" >待收货</span>
                <span v-if="scope.row.receiveStatus==2">部分收货</span>
                <span v-if="scope.row.receiveStatus==3">收货完成</span>
              </div>
              <div>
                售后仓退货状态：<span v-if="scope.row.check==0" >待签收</span>
                <span v-else-if="scope.row.check==1" >已签收</span>
                <span v-else >已入库</span>
              </div>
            </template>
          </el-table-column>

<!--          <el-table-column-->
<!--              label="外包装图片"-->
<!--              min-width="100"-->
<!--              prop="pictureUrl"-->
<!--          >-->
<!--            <template #default="scope">-->
<!--              <MyImage v-if="scope.row.outerImage.length>0" :picture-url="scope.row.outerImage[0]" :picture-url-list="scope.row.outerImage"></MyImage>-->
<!--              <span v-else >暂无图片</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--              label="设备通电图片"-->
<!--              min-width="100"-->
<!--              prop="pictureUrl"-->
<!--          >-->
<!--            <template #default="scope">-->
<!--              <MyImage v-if="scope.row.equipmentImage.length>0" :picture-url="scope.row.equipmentImage[0]" :picture-url-list="scope.row.equipmentImage"></MyImage>-->
<!--              <span v-else >暂无图片</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
              label="退回备注"
              min-width="80"
              prop="receiveRemarks"
          >
            <template #default="scope">
              <el-tooltip
                  class=""
                  effect="dark"
                  :content="scope.row.receiveRemarks"

              >
                <span class="ellipsis-3-lines" >{{scope.row.receiveRemarks}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              min-width="80"
              prop="addServices"
          >
            <template #default="scope">
              <!--v-if="scope.row.activeStatus==0"-->
              <el-button link type="primary" size="small" @click="handleClick(scope.row)">售后详情</el-button>
              <el-button :disabled ="scope.row.receiveStatus==3 || scope.row.check" link type="primary" size="small" @click="check(scope.row)">退货入库</el-button>
              <el-button  link type="primary" size="small" @click="checkInfo(scope.row)">退货详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>
    <arehouseAndQuality ref="arehouseAndQuality"  @closeEdit="close" ></arehouseAndQuality>
    <receiptZendesk ref="receiptZendesk"  @closeEdit="close" ></receiptZendesk>
    <receiptInfo ref="receiptInfo"  @closeEdit="close" ></receiptInfo>
    
    <!-- 超时预警弹窗 -->
    <el-dialog
      v-model="timeoutDialogVisible"
      title="超时预警信息  (无退货单号待收货且有登记人)"
      width="80%"
      :close-on-click-modal="false"
      style="height: 80vh; display: flex; flex-direction: column;"
    >
      <!-- 固定的用户导航栏 -->
      <div v-if="timeoutData.length > 0" class="user-nav-list" style="padding: 15px; background-color: #f5f7fa; border-bottom: 1px solid #dcdfe6; position: sticky; top: 0; z-index: 10; margin: 0;" ref="userNavRef">
        <div style="display: flex; flex-wrap: wrap; gap: 8px; justify-content: space-between; align-items: center;">
          <div style="display: flex; flex-wrap: wrap; gap: 8px; justify-content: center; flex: 1;">
          <button 
            v-for="(userData, index) in timeoutData" 
            :key="index"
            :id="`nav-${index}`"
            @click="scrollToUserSection(index)"
            class="user-nav-item"
            style="padding: 6px 12px; border: 1px solid #409eff; border-radius: 4px; background-color: #409eff; color: white; cursor: pointer; font-size: 12px; transition: all 0.3s;"
            :style="{ 
              backgroundColor: activeUserId === index ? '#409eff' : '#409eff',
              color: 'white',
              borderColor: activeUserId === index ? '#409eff' : '#409eff'
            }"
            @mouseenter="hoverUserId = index"
            @mouseleave="hoverUserId = null"
          >
            {{ userData.username }} ({{ userData.value ? userData.value.length : 0 }})
          </button>
          </div>
          <div style="margin-left: 10px;">
            <el-button type="primary" size="small" @click="handleExportExcel">一键导出</el-button>
            <el-button type="danger" size="small" @click="handleAllNotify" style="margin-left: 10px;">一键通知</el-button>
          </div>
        </div>
      </div>
      <!-- 可滚动的内容区域 -->
      <div v-if="timeoutData.length > 0" style="flex: 1; overflow-y: auto; max-height: calc(80vh - 180px);">
        <div v-for="(userData, index) in timeoutData" :key="index" :id="`user-section-${index}`" class="user-section" style="margin-bottom: 30px; padding: 0 15px;">
          <div style="display: flex; align-items: center;">
            <h3 class="user-name" style="text-align: center; flex: 1; margin-bottom: 0;">{{ userData.username }} 的超时数据 ({{ userData.value ? userData.value.length : 0 }}条)<el-button type="success" size="small" @click="handleUserNotify(userData.username)" style="margin-left: 10px;">通知跟进</el-button></h3>
            
          </div>
          <div v-if="userData.value && userData.value.length > 0">
              <el-table :data="userData.value" style="margin-bottom: 20px;">
                <el-table-column prop="platformOrderId" label="平台订单号" min-width="180" header-align="center"></el-table-column>
                <el-table-column prop="salesRecordNumber" label="交易号" min-width="150" header-align="center"></el-table-column>
                <el-table-column prop="shopName" label="店铺名称" min-width="180" header-align="center"></el-table-column>
                <el-table-column prop="title" label="产品名称" min-width="150" header-align="center"></el-table-column>
                <el-table-column prop="stockSku" label="库存SKU" min-width="150" header-align="center"></el-table-column>
                <el-table-column prop="stockWarehouseName" label="库存仓库名称" min-width="200" header-align="center"></el-table-column>
                <el-table-column label="超时天数" min-width="120" header-align="center">
                  <template #default="scope">
                    <span style="font-weight: bold; color: red; display: block; text-align: center;">{{ scope.row.days_difference || 0 }}天</span>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" min-width="150" header-align="center">
                  <template #default="scope">
                    <el-tooltip :content="scope.row.remark || '无'" placement="top">
                      <span class="ellipsis-1-line">{{ scope.row.remark || '' }}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="createDate" label="创建日期" min-width="145" header-align="center"></el-table-column>
                <el-table-column prop="returnTrackNumber" label="退货单号" min-width="120" header-align="center"></el-table-column>
              </el-table>
          </div>
          <div v-else class="no-data">暂无超时数据</div>
        </div>
      </div>
      <div v-else class="no-overtime-data">暂无超时预警数据</div>
    </el-dialog>
  </div>
</template>
<script>
import {ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,ElTooltip,

  ElTableColumn,ElPagination,ElSelect,ElOption} from "element-plus";
import arehouseAndQuality from "@/components/arehouseAndQuality.vue";
import receiptZendesk from "@/components/receiptZendesk.vue";
import receiptInfo from "@/components/receiptInfo.vue";
import MyImage from "@/components/myImage.vue";
import {getReceipt, getTimeout_receipt, gettimeout_reminder} from "@/utils/api";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import {getLocalStockList} from "../../../public/js";
import {baseUrl} from "@/utils/requset";
import * as XLSX from "xlsx";
export default {
  name: "signReceipt",
  mixins:[DynamicHeightMixin],
  components: {receiptZendesk,receiptInfo,arehouseAndQuality,ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,MyImage,ElSelect,ElOption,
    ElTableColumn,ElPagination,ElTooltip},
  data() {
    return {
      activeUserId: null,
      hoverUserId: null,
      formInline:{
        startMonth:"2025-09-18",
        country:["US","CA","MX"],
        status:[3,5],
      },
      receiveList:[
        {label:"暂无退货单号",value:"None"},
      ],
      resiveList:[
          {label:"物流未签收",value:1},
          {label:"物流已签收",value:2},
          {label:"马帮未签收",value:3},
          {label:"马帮已签收",value:4},
          {label:"仓库未签收",value:5},
          {label:"仓库已签收",value:6}
      ],
      countryList:[
        {label: "美国", value: "US"},
        {label: "加拿大", value: "CA"},
        {label: "墨西哥", value: "MX"},
        {label: "德国", value: "DE"},
        {label: "澳大利亚", value: "AU"},
      ],
      tableData:[],
      stockList:[],
      currentPage:1,
      pageTotal:0,
      pageSize:20,
      timeoutDialogVisible: false,
      timeoutData: []
    }
  },
  beforeMount() {
    this.getReceipt();
    this.getLocalStockList()
  },
  methods:{
    // 滚动到指定用户区域
    scrollToUserSection(index) {
      this.activeUserId = index;
      const element = document.getElementById(`user-section-${index}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    showTimeoutWarning() {
      getTimeout_receipt().then(res => {
        this.timeoutData = res.Data;
        this.timeoutDialogVisible = true;
      }).catch(err => {
        console.error('获取超时预警数据失败:', err);
        this.$message.error('获取超时预警数据失败');
      });
    },
    exportData(){
      let pramas = Object.entries(this.formInline)
          .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
          .join('&');
      let url = baseUrl + 'after/receiptExport?'+ pramas

      window.open(url)
    },
    onSubmit(){
      this.PageNumber = 1
      this.getReceipt()
    },
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓")
        })
      })
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getReceipt();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getReceipt();
    },
    getReceipt(){
      getReceipt({...this.formInline,PageSize:this.pageSize,PageNumber:this.currentPage}).then(res=>{
        this.tableData = res.Data
        this.pageTotal = res.Total
      }).catch(res=>{
        console.log(res)
      })
    },
    handleClick(data){
      this.$refs.receiptZendesk.open(data)
    },
    // 一键通知所有用户
    handleAllNotify() {
      this.$confirm('确定要发送一键通知吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        gettimeout_reminder().then(() => {
            this.$message.success('通知发送成功');
          }).catch(err => {
          console.error('发送通知失败:', err);
          this.$message.error('通知发送失败');
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
    // 通知特定用户
    handleUserNotify(username) {
      this.$confirm(`确定要发送通知给 ${username} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        gettimeout_reminder({ username }).then(() => {
            this.$message.success(`通知 ${username} 发送成功`);
          }).catch(err => {
          console.error('发送通知失败:', err);
          this.$message.error('通知发送失败');
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
    check(data){
      this.$refs.arehouseAndQuality.open(data,"个人退货")
    },
    checkInfo(data){
      this.$refs.receiptInfo.open(data,"个人退货")
    },
    close(){
      this.getReceipt()
    },
    // 导出Excel
    handleExportExcel() {
      // 准备导出数据
      const exportData = [];
      
      // 遍历所有用户数据
      this.timeoutData.forEach((userData) => {
        const username = userData.username;
        const dataList = userData.value || [];
        
        // 如果该用户有数据，则添加到导出数组中
        if (dataList.length > 0) {
          dataList.forEach((item) => {
            exportData.push({
              '用户': username,
              '平台订单号': item.platformOrderId,
              '交易号': item.salesRecordNumber,
              '店铺名称': item.shopName,
              '产品名称': item.title,
              '库存SKU': item.stockSku,
              '库存仓库名称': item.stockWarehouseName,
              '退货单号': item.returnTrackNumber,
              '创建日期': item.createDate,
              '超时天数': item.days_difference || 0,
              '备注': item.remark || ''
            });
          });
        } else {
          // 即使没有数据也添加一行表示该用户无数据
          exportData.push({
            '用户': username,
            '平台订单号': '',
            '交易号': '',
            '店铺名称': '',
            '产品名称': '',
            '库存SKU': '',
            '库存仓库名称': '',
            '退货单号': '',
            '创建日期': '',
            '超时天数': '',
            '备注': '暂无超时数据'
          });
        }
      });
      
      // 创建工作表
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      
      // 创建工作簿
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "超时数据");
      
      // 导出文件
      const timestamp = new Date().getTime();
      XLSX.writeFile(workbook, `超时预警数据_${timestamp}.xlsx`);
    }
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container {
  .el-form-item{
    margin-bottom:0!important;
  }
}
::v-deep .el-table .el-table__cell{
  box-sizing: border-box;
  min-width: 0;
  padding: 8px 0;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  z-index: unset !important;
}
::v-deep .el-table .el-button+.el-button{
  margin-left: 0 !important;
}
.pagination{
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-button+.el-button {
  margin-left: 10px;
}

.user-section {
  margin-bottom: 30px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 6px;
}

.user-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #303133;
  border-bottom: 1px solid #dcdfe6;
  padding-bottom: 8px;
}

.no-data,
.no-overtime-data {
  text-align: center;
  color: #909399;
  padding: 20px;
  font-size: 14px;
}

.ellipsis-1-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
}

/* 确保超时预警表格内容左对齐 */
::v-deep .user-section .el-table {
  width: 100% !important;
  table-layout: fixed !important;
}

::v-deep .user-section .el-table .el-table__cell {
  text-align: left;
  padding-left: 15px;
  padding-right: 10px;
  box-sizing: border-box;
}

::v-deep .user-section .el-table .el-table__header .el-table__cell .cell {
  text-align: center !important;
  font-weight: bold;
}

/* 确保表格单元格div内容也左对齐 */
::v-deep .user-section .el-table .el-table__cell .cell {
  text-align: left !important;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 大屏适配 */
@media (min-width: 1600px) {
  ::v-deep .user-section .el-table {
    font-size: 14px;
  }
  
  ::v-deep .user-section .el-table .el-table__row {
    height: 40px;
  }
  
  ::v-deep .user-section .el-table .el-table__cell {
    padding-left: 18px;
    padding-right: 12px;
  }
}
</style>